import LangEnum from '../../../../lang/LangEnum';
import { CatalogCardVariantKey } from '../../../../modules/catalogs/products/v2/sizing/catalogCardColumns.types';
import ProductPricesRenderer from '../../../../modules/products/prices/ProductPricesRenderer';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { ProductCardV2TestIds } from '../../../../utils/testIds/ProductCardV2.testIds';
import Typography from '../../../v2/ui/Typography/Typography';
import ProductActions from '../../ProductActions';
import ProductCardV2Colors from './components/ProductCardV2Colors';
import ProductCardV2Heading from './components/ProductCardV2Heading';
import ProductCardV2Media from './components/ProductCardV2Media';
import { useProductCardV2Styles } from './productCardV2.styles';
import { ProductCardV2Props } from './types/productCardV2.types';
import useProductCardV2View from './useProductCardV2View';

const ProductCardV2 = (props: ProductCardV2Props) => {
  const { item, catalogId, shoppingButtonTooltipMessage, selection, visibility, size } = props;
  const { showPrices = true, showShoppingAction = true } = visibility ?? {};
  const { translate } = useTranslation();
  const { classes } = useProductCardV2Styles({ size });
  const view = useProductCardV2View(props);

  const isMediaOnly = size === CatalogCardVariantKey.SMALL;

  return (
    <div test-id={ProductCardV2TestIds.CARD} className={classes.root}>
      <ProductCardV2Media
        catalogId={catalogId}
        tags={view.tags}
        productName={item.name}
        medias={item.medias}
        entityRelations={item.entityRelations}
        selection={selection}
        size={size}
      />

      {!isMediaOnly && (
        <div onClick={view.onCardClick} className={classes.infoSection}>
          <div className={classes.infoHeader}>
            <div className={classes.infoMain}>
              <ProductCardV2Heading
                name={item.name}
                code={item.code}
                referenceCode={item.referenceCode}
                entityRelations={item.entityRelations}
              />

              <ProductCardV2Colors
                allColors={item.allColors}
                selectedColor={item.selectedColor}
                onColorClick={view.onColorClick}
              />
            </div>

            {showShoppingAction && (
              <ProductActions
                loading={view.shopping.loading}
                isShopping={view.shopping.isShopping}
                canAddShopping={item.availableForSale}
                shoppingButtonTooltipMessage={shoppingButtonTooltipMessage}
                onClickShopping={view.shopping.onClickShopping}
              />
            )}
          </div>

          {showPrices &&
            !view.price.shouldDisableAllPrices &&
            (view.price.hasPrices ? (
              <ProductPricesRenderer
                prices={item.prices}
                retailPriceDisabled={view.price.disableRetailPrice}
                wholesalePriceDisabled={view.price.disableWholesalePrice}
              />
            ) : (
              <Typography variant="body2" color="textSecondary">
                {translate(LangEnum.PRODUCT_DETAILS_UNAVAILABLE_GRID)}
              </Typography>
            ))}
        </div>
      )}
    </div>
  );
};

export default ProductCardV2;
